import { useMemo } from 'react';

import { useLocalSearchParams } from 'expo-router';

/**
 * Parses target item ids from menu section deep links / web URLs.
 *
 * Accepted form: `?targetItemIds=<id1>,<id2>,…`. A single id is just a list
 * of length one (`?targetItemIds=<id>`). Returns an ordered, de-duplicated
 * list — the URL order defines the order in which matching items are pinned
 * to the top of the section.
 */
export const useTargetItemIds = (): string[] => {
  const { targetItemIds } = useLocalSearchParams<{ targetItemIds?: string | string[] }>();

  return useMemo(() => {
    if (!targetItemIds) {
      return [];
    }
    const raw = Array.isArray(targetItemIds) ? targetItemIds : [targetItemIds];
    const ids = raw.flatMap(value =>
      value
        .split(',')
        .map(part => part.trim())
        .filter(Boolean)
    );
    return Array.from(new Set(ids));
  }, [targetItemIds]);
};
